<div class="modal-header">
  <h5 class="modal-title">{{ "BULK_EDIT_ACTIVITY" | translate }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClose()"
  ></button>
</div>
<div class="modal-body">
  <div *ngIf="selectorVisible" class="form-group row mb-3 grid-filters">
    <div class="col-md-3">
      <app-select-academic-year-only
        [academic_year]="filters.academic_year"
        (academicYearChanged)="onChangeAcademicYear($event)">
      </app-select-academic-year-only>
    </div>
    <div class="col-md-3">
      <app-select-school-level-relation-v2
        [academic_year]="filters.academic_year"
        [selectedLocationId]="filters.school_location_id"
        [usingLocalStorage]="false"
        (schoolLevelRelationChanged)="onChangeSchoolLevel($event)">
      </app-select-school-level-relation-v2>
    </div>
    <div class="col-md-3">
      <app-select-school-program
        [selectedProgramId]="filters.school_program_id"
        [academic_year]="filters.academic_year"
        [school_location_id]="filters.school_location_id"
        [usingLocalStorage]="false"
        (schoolProgramChanged)="onChangeSchoolProgram($event)">
      </app-select-school-program>
    </div>
    <div class="col-md-3">
      <app-select-school-program-category
        [school_program_id]="filters.school_program_id"
        [usingLocalStorage]="false"
        [all]="true"
        (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event)">
      </app-select-school-program-category>
    </div>
  </div>
  <p class="grid-hint">
    School program and category filters are optional. Add or edit activities
    directly in the grid.
  </p>
  <div *ngIf="!hasSchoolLevel" class="grid-loading">
    Select an academic year and school level to show the grid.
  </div>
  <div *ngIf="hasSchoolLevel && !loading" class="grid-actions">
    <button
      type="button"
      class="action-btn action-btn-edit"
      (click)="onAddRow()"
    >
      + Add row
    </button>
    <span class="revo-grid-legend">
      <span class="revo-grid-legend-swatch"></span>
      {{ "GRID_REQUIRED_LEGEND" | translate }}
    </span>
  </div>
  <div *ngIf="hasSchoolLevel && loading" class="grid-loading">Loading…</div>
  <revo-grid
    *ngIf="hasSchoolLevel && !loading"
    #activityGrid
    class="activity-grid"
    theme="material"
    [columns]="columns"
    [columnTypes]="columnTypes"
    [source]="source"
    [rowSize]="32"
    [applyOnClose]="true"
    [resize]="true"
    [range]="true"
    [canFocus]="true"
    [useClipboard]="clipboardConfig"
    [rowHeaders]="true"
    [stretch]="true"
    [hideAttribution]="true"
    [plugins]="gridPlugins"
    (newRows)="onNewRows($event)"
    (beforekeydown)="onGridKeydown($event)"
    (afteredit)="onAfterEdit($event)"
  ></revo-grid>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="action-btn"
    (click)="onClose()"
    [disabled]="saving"
  >
    {{ "CANCEL" | translate }}
  </button>
  <button
    type="button"
    class="action-btn action-btn-create"
    (click)="onSave()"
    [disabled]="saving || loading || !hasSchoolLevel"
  >
    {{ (saving ? "SAVING" : "SAVE") | translate }}
  </button>
</div>
